import { render, staticRenderFns } from "./_user_image.vue?vue&type=template&id=67a091c4&scoped=true&"
import script from "./_user_image.vue?vue&type=script&lang=js&"
export * from "./_user_image.vue?vue&type=script&lang=js&"
import style0 from "./_user_image.vue?vue&type=style&index=0&id=67a091c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a091c4",
  null
  
)

export default component.exports